import * as React from 'react'
import TopNavigationClever from './TopNavigationClever'
import TopTestingNavigation from './TopTestingNavigation'
import {HeaderContainer} from './HeaderCleverStyle'

export const Header = () => {
  return (
    <HeaderContainer>
      <TopTestingNavigation />
      <TopNavigationClever />
    </HeaderContainer>
  )
}

export default Header



// WEBPACK FOOTER //
// ./src/components/layout/HeaderClever.tsx